/* eslint-disable react-hooks/exhaustive-deps */
import Badge from '@panel/commons/lib/badge';
import React from 'react';
import styled, { css } from 'styled-components';
import { useObserver } from 'mobx-react';
import { getColor } from '@panel/commons/core/themev3';

const deskTopStyle = css`
  position: absolute;
  right: -4px;
  top: 5px;
  z-index: 1;
`;

const mobileStyle = css`
  position: relative;
  margin-left: 8px;
`;

const BadgeWrapper = styled.div`
  ${({ isMobile }) => (isMobile ? mobileStyle : deskTopStyle)}
`;

const ItemBadget = ({ isMobile = false, text }) => {
  return useObserver(() => (
    <BadgeWrapper isMobile={isMobile}>
      <Badge as='div' value={text} color={getColor('primary')} />
    </BadgeWrapper>
  ));
};

export default ItemBadget;
